import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Icons from "../../myIcon/Icons";
import { BaseUrl } from "../../helper/BaseUrl";
import { usePermissions } from "../../helper/PermissionContext";

export default function SideBar({ isOpen, toggleSidebar }) {
  const [blogOpen, setBlogOpen] = useState(false);
  const [usersOpen, setUsersOpen] = useState(false);
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await axios.post(`${BaseUrl}api/logout`, {}, { withCredentials: true });
    } finally {
      localStorage.removeItem("accessTokenBigbin");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
      navigate("/login", { replace: true });
    }
  };

  return (
    <>
      <div className={`admin-logo-wrap ${isOpen ? "close" : "open"}`}>
        <img src="/logo.webp" alt="logo" className="img-responsive" />
        <button className="toggle-button" onClick={toggleSidebar}>☰</button>
      </div>
      <div className={`admin-sidebar ${isOpen ? "close" : "open"}`}>
        <div className="scroller-sidebar">
          <ul style={isOpen ? { opacity: "0" } : { opacity: "1" }}>
            {hasPermission("dashboard") && (
              <li>
                <Link to="/">
                  <span>
                    <img src="/assets/dashboard.webp" alt="" className="img-responsive" />
                    Dashboard
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("user-management") && (
              <li className={`innertab ${usersOpen ? "openlist" : ""}`} onClick={() => setUsersOpen(!usersOpen)}>
                <div>
                  <span>
                    <img src="/assets/dashboard.webp" alt="" className="img-responsive" />
                    User Management
                  </span>
                  <Icons name="arrowDown" />
                </div>
                <ul className={`nested-list ${usersOpen ? "open" : "close"}`}>
                  <li><Link to="/users">Users</Link></li>
                  <li><Link to="/roles">Roles</Link></li>
                  <li><Link to="/permissions">Permissions</Link></li>
                </ul>
              </li>
            )}

            {hasPermission("blog-management") && (
              <li className={`innertab ${blogOpen ? "openlist" : ""}`} onClick={() => setBlogOpen(!blogOpen)}>
                <div>
                  <span>
                    <img src="/assets/blog-management.webp" alt="" className="img-responsive" />
                    Blog Management
                  </span>
                  <Icons name="arrowDown" />
                </div>
                <ul className={`nested-list ${blogOpen ? "open" : "close"}`}>
                  <li><Link to="/blog">Blog</Link></li>
                  <li><Link to="/category">Category</Link></li>
                  <li><Link to="/author">Author</Link></li>
                </ul>
              </li>
            )}

            {hasPermission("contact") && (
              <li>
                <Link to="/contact">
                  <span>
                    <img src="/assets/blog-management.webp" alt="" className="img-responsive" />
                    Contact
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("Business-contact") && (
              <li>
                <Link to="/business-contact">
                  <span>
                    <img src="/assets/blog-management.webp" alt="" className="img-responsive" />
                    Business Contact
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("faq-management") && (
              <li>
                <Link to="/faq">
                  <span>
                    <img src="/assets/blog-management.webp" alt="" className="img-responsive" />
                    FAQ Management
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("seo-management") && (
              <li>
                <Link to="/seo">
                  <span>
                    <img src="/assets/seo-management.webp" alt="" className="img-responsive" />
                    SEO Management
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("global-seo") && (
              <li>
                <Link to="/global-seo">
                  <span>
                    <img src="/assets/schema-management.webp" alt="" className="img-responsive" />
                    Global SEO
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("sitemap-management") && (
              <li>
                <Link to="/sitemap">
                  <span>
                    <img src="/assets/sitemap-management.webp" alt="" className="img-responsive" />
                    Sitemap Management
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("llms-management") && (
              <li>
                <Link to="/llms">
                  <span>
                    <img src="/assets/sitemap-management.webp" alt="" className="img-responsive" />
                    LLMS Management
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("robots-management") && (
              <li>
                <Link to="/robots">
                  <span>
                    <img src="/assets/sitemap-management.webp" alt="" className="img-responsive" />
                    Robots.txt Management
                  </span>
                </Link>
              </li>
            )}

            {hasPermission("email-management") && (
              <li>
                <Link to="/email-management">
                  <span>
                    <img src="/assets/blog-management.webp" alt="" className="img-responsive" />
                    Email Management
                  </span>
                </Link>
              </li>
            )}
          </ul>
        </div>
        <button onClick={logout} className="default-btn logout-button">Logout<span></span></button>
      </div>
    </>
  );
}
